import {inject} from '@angular/core';
import {ApolloClientOptions, ApolloLink, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {setContext} from '@apollo/client/link/context';
import {ErrorLinkService} from '@shared/services/errorlink.service';
import {AuthHeaderService} from '@shared/services/auth-header.service';
import {environment} from '../../../environments/environment';


export const apolloClientFactory = ():Record<string, ApolloClientOptions<any>> => {
    const httpLink = inject(HttpLink);
    const errorLinkService = inject(ErrorLinkService);
    const authHeaderService = inject(AuthHeaderService);
    const errorLink = errorLinkService.createErrorLink();

    // Logging link
    const loggingLink = new ApolloLink((operation, forward) => {
        return forward(operation).map((response) => {
            return response;
        });
    });


  const authLink = setContext(async (_, { headers = {}, customHeaders = {} }) => {
    let updatedHeaders = { ...headers };
    updatedHeaders = await authHeaderService.appendAuthToken(updatedHeaders, customHeaders);
    if (!updatedHeaders.Organisation) {
      updatedHeaders = await authHeaderService.appendCustomHeaders(updatedHeaders, customHeaders);
    }
    return { headers: updatedHeaders };
  });

  let defaultLinks = [authLink, errorLink, httpLink.create({uri: environment.TMP_GRAPHQL_BASE})];
    if (!environment.production) {
      defaultLinks.unshift(loggingLink);
    }

  let meshLinks = [authLink, errorLink, httpLink.create({uri: environment.MESH_GRAPHQL_BASE})];
    if (!environment.production) {
      meshLinks.unshift(loggingLink);
    }

    return {
      default: {
        link: ApolloLink.from(defaultLinks),
        cache: new InMemoryCache(),
        defaultOptions: {
          query: {
            fetchPolicy: 'network-only', // Default behavior for query
            errorPolicy: 'all',
          },
          mutate: {
            fetchPolicy: 'network-only', // Default behavior for mutate
            errorPolicy: 'all',
          }
        },
      },
        mesh: {
          link: ApolloLink.from(meshLinks),
          cache: new InMemoryCache(),
          defaultOptions: {
            query: {
              fetchPolicy: 'no-cache',
              errorPolicy: 'all',
            },
            mutate: {
              fetchPolicy: 'no-cache',
              errorPolicy: 'all',
            }
        }
      }
    };
};
